export const DEFAULT_PAGINATION_PAGE = 1;
export const DEFAULT_PAGINATION_PAGE_LIMIT = 25;
